import { Button, Group, Loader, Modal, Text } from '@mantine/core';
import { useState } from 'react';
import { useIntl } from 'react-intl';
import { useAppDispatch } from '@store';
import { deleteFilterWithNotification } from '@store/slices/filtersSlice';

export const DeleteModal = ({
  filter,
  onClose,
}: {
  filter: any;
  onClose: () => void;
}) => {
  const intl = useIntl();
  const dispatch = useAppDispatch();
  const [isDeleting, setIsDeleting] = useState<boolean>(false);

  const handleDelete = async () => {
    try {
      setIsDeleting(true);
      await dispatch(deleteFilterWithNotification(filter.owner, filter));
      onClose();
    } catch (err: any) {
      // Error notification is handled in the thunk
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      title={intl.formatMessage({ id: 'delete' })}
      size="lg"
      centered
      opened={filter !== null}
      onClose={onClose}
      closeOnClickOutside={!isDeleting}
      closeOnEscape={!isDeleting}
      withCloseButton={!isDeleting}
    >
      <Text>
        {intl.formatMessage({ id: 'areYouSureYouWantToDelete' })}"
        <strong>{filter?.name}</strong>"?
      </Text>

      <Group mt="lg" justify="flex-end">
        <Button disabled={isDeleting} onClick={onClose} variant="default">
          {intl.formatMessage({ id: 'cancel' })}
        </Button>
        <Button
          leftSection={isDeleting ? <Loader size="xs" /> : undefined}
          disabled={isDeleting}
          onClick={handleDelete}
          color="red"
        >
          {intl.formatMessage({ id: 'delete' })}
        </Button>
      </Group>
    </Modal>
  );
};
